import React, { useState } from 'react';
import axios from '../helpers/axiosConfig';

const AddMinistreSuccessifs = () => {
  console.log('Tonga');
  const [formData, setFormData] = useState({
    nomprenom: '',
    categorie: '',
    du: '',
    au: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/ministresuccessifs/add', formData);
    } catch (error) {
      console.error("Erreur lors de l'ajout:", error);
    }
  };

  return (
    <div className="container mt-5 pt-4">
      <div className="row">
        <div className="col bg-warning p-3 ">Ajout nouveau Ministre</div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col">
            <label htmlFor="nomprenom"> Nom et prénoms </label>
            <input className="form-control" name="nomprenom" value={formData.nomprenom} onChange={handleChange} placeholder="Nom et prénom" required />
          </div>
          <div className="col">
            <label htmlFor="categorie"> Catégorie </label>
            <input className="form-control" name="categorie" value={formData.categorie} onChange={handleChange} placeholder="Catégorie" required />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="du"> du</label>
            <input className="form-control" type="date" name="du" value={formData.du} onChange={handleChange} required />
          </div>
          <div className="col">
            <label htmlFor="au"> au </label>

            <input className="form-control" type="date" name="au" value={formData.au} onChange={handleChange} required />
          </div>
        </div>
        <div className="row">
          <button type="submit" className=" m-3 btn btn-primary">
            Ajouter
          </button>
          .
        </div>
      </form>
    </div>
  );
};

export default AddMinistreSuccessifs;
